<template>
  <div class="ma-4">
    <PopupCreate @onCreate="onRefresh" ref="popup-create" />
    <div class="d-flex justify-end">
      <BaseButton text="Thêm đầu điểm" icon="mdi-plus" @click="() => $refs['popup-create'].openPopup()" />
    </div>
    <div class="mt-6">
      <v-row>
        <v-col
          v-for="(mark, index) in displayedMarks"
          :key="mark.id"
          :cols="mark.isGroup ? 12 : 4"
          :class="{ 'pl-0': !mark.isGroup && index % 3 !== 0 }"
        >
          <MarkGroup v-if="mark.isGroup" :groupMark="mark" @onRefresh="onRefresh" />
          <Mark v-else :mark="mark" @onRefresh="onRefresh" />
        </v-col>
      </v-row>
    </div>
    <div class="text-caption font-italic mt-4">Lưu ý: Khung điểm này sẽ chỉ áp dụng cho các lớp được tạo mới sau khi cấu hình.</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '../../../../components/basic/BaseButton.vue'
import PopupCreate from './PopupCreate.vue'
import Mark from './CardView.vue'
import MarkGroup from './GroupView.vue'
export default {
  components: { BaseButton, PopupCreate, Mark, MarkGroup },
  computed: {
    ...mapGetters({
      displayedMarks: 'gradeMark/getDisplayedMarks',
    }),
  },
  methods: {
    ...mapActions({
      fetchAll: 'gradeMark/fetchAll',
    }),
    async onRefresh() {
      await this.fetchAll({ grade: this.$route.params.id })
    },
  },
  async created() {
    await this.onRefresh()
  },
}
</script>
